import Panel from './panel';
import { showTag, hideTag, tagOnClick } from '../utils';
import QRCode, { CorrectLevel } from '../../vendor/qrcode/index';
import clipboard from 'clipboard-polyfill';

export default class ErrorPanel extends Panel {
  render() {
    this.tags.filter(t => t.classNames !== 'background').forEach(t => hideTag(t));

    if (this.isIOSChrome()) {
      this.showCopyLink();
    } else if (this.isIOSWebView()) {
      this.showCopyLink();
    } else if (this.isIOS()) {
      this.showSafariCameraInstructions();
    } else if (this.isMobile()) {
      this.showMobileError();
    } else {
      this.showQRCode();
    }
  }

  showCopyLink() {
    this.setMessage(
      `This experience only works in Safari. Copy this page's URL below and open it in Safari.`
    );

    const copyButton = this.getTag('link-cta');

    showTag(copyButton);
    tagOnClick(copyButton, () => {
      clipboard.writeText(document.location.toString());
    });
  }

  showSafariPointer() {
    this.setMessage(
      'This experience only works in Safari. Tap the Safari icon below to open in Safari.'
    );

    showTag(this.getTag('safari-pointer-arrow'));
  }

  showSafariCameraInstructions() {
    this.setMessage('This experience requires camera access. Enable it in Settings:');

    showTag(this.getTag('camera-screenshot'));
  }

  showMobileError() {
    this.setMessage(`Unfortunately, this AR experience won't work on this browser and/or device.`);

    showTag(this.getTag('error-requirements'));
    showTag(this.getTag('error-requirements-list'));
  }

  showQRCode() {
    const screenshot = this.getTag('camera-screenshot');

    if (screenshot) {
      this.setMessage(
        `This experience only works on devices with camera access enabled. You can try it on your ` +
          `mobile device by opening its camera and scanning this QR code:`
      );

      const message = this.getTag('error-message');

      if (message) {
        message.element.style.top = '100px';
      }

      showTag(screenshot);

      screenshot.element.innerHTML = '';

      const size = screenshot.width;

      new QRCode(screenshot.element, {
        text: document.location.toString(),
        width: size,
        height: size,
        correctLevel: CorrectLevel.H
      });
    }
  }

  setMessage(text) {
    const message = this.getTag('error-message');

    if (message) {
      message.element.innerHTML = text;
      message.element.style.display = 'block';
    }
  }

  isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  isIOSChrome() {
    return /CriOS/.test(navigator.userAgent);
  }

  isIOSWebView() {
    return this.isIOS() && !this.isMobileSafari();
  }

  // This check requires the following HTML tag to be present
  // somewhere in the document when it is initially loaded:
  //
  //   <p id="safari-tester" style="display: none">256-512-1024</p>
  //
  // It works because MobileSafari automatically linkifies
  // telephone numbers, but WKWebViews do not, by default. It
  // is still possible that some app owner has enabled it in
  // their webviews, but we have not come across it yet.
  isMobileSafari() {
    return !!document.querySelector('#safari-tester a');
  }

  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
}
